import { render } from "./ParkingItemsContainer.vue?vue&type=template&id=b6b5c954&scoped=true"
import script from "./ParkingItemsContainer.vue?vue&type=script&lang=js"
export * from "./ParkingItemsContainer.vue?vue&type=script&lang=js"

import "./ParkingItemsContainer.vue?vue&type=style&index=0&id=b6b5c954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b5c954"]])

export default __exports__